import React from "react"
import propTypes from "prop-types"
import { useEffect, useState } from "react"
import i18n from "i18n"
import { Box } from "@mui/material"
import { useAuthContext } from "context/auth/authContext"
import { getLastRow } from "./estructureUtils"
import { getCurrency } from "utils/functions"
import { useBudget2023Context } from "context/budget2023/Budget2023Context"
import { useWrapperModals } from "context/wrapperModals/WrapperModalsContext"
import { NEW_STRUCTURE } from "context/types"
import useBudgetConfig from "hooks/budgeting/useBudgetConfig"
import useEntitlementGuard from "hooks/useEntitlementGuard"
import { IMPORT_BC3_LINK } from "constants/entitlements"
import AddPartidaActions from "../AddPartidaActions"

const Estructura = ({
  certificaciones,
  children,
  esUnico,
  soyFinal,
  capitulo,
  projectInfo,
  version,
  setOpenModalCreatePartida,
}) => {
  const [budgetConfig] = useBudgetConfig()
  const preferencias = budgetConfig.preferences

  const [margen, setMargen] = useState("0px")
  const { freeTrialExpired, openFreeTrialExpire, user } = useAuthContext()
  const { isBudgetClosed, budgetMode, baseCert } = useBudget2023Context()
  const [checkEntitlement, entitlementDialog] = useEntitlementGuard()

  const handleCreatePart = () => {
    if (soyFinal) return
    setOpenModalCreatePartida(true)
  }

  const { bc3Link, partBrowser } = useWrapperModals()

  const openModalImportFromBc3Link = () => {
    bc3Link.setProperty({
      open: true,
      from: NEW_STRUCTURE,
      chapterId: capitulo.capituloInfo.chapterId,
    })
  }

  const handleSearchPart = () => {
    if (soyFinal) return
    partBrowser.setProperty({
      open: true,
      from: NEW_STRUCTURE,
      chapterId: capitulo.capituloInfo.chapterId,
    })
  }

  const importBC3FromLink = () => {
    if (freeTrialExpired) {
      openFreeTrialExpire()
      return
    }

    if (!checkEntitlement(IMPORT_BC3_LINK, i18n.t("importBC3Link.link"))) return

    openModalImportFromBc3Link()
  }

  useEffect(() => {
    if (esUnico != undefined) {
      if (esUnico == true) {
        setMargen("20px")
      } else {
        setMargen("0px")
      }
    } else {
      setMargen("0px")
    }
  }, [])

  const isBaseCertClient = baseCert === "client"
  const currencySymbol = getCurrency(user["custom:currency"])

  return (
    <>
      <div id="table-wrapper">
        <div id="table-scroll" style={{ overflowX: "auto" }}>
          <table
            className="tablaPartidas"
            style={{
              marginLeft: "0px",
              marginBottom: "8px",
              marginBottom: margen,
            }}
          >
            <tbody>
              <tr style={{ borderBottom: " solid #E9ECEF" }}>
                <th
                  style={{
                    minWidth: "64px",
                    maxWidth: "96px",
                    paddingLeft: "15px",
                    borderLeft: "none",
                  }}
                ></th>
                {preferencias.basededatos == true &&
                preferencias.clientPrice == true ? (
                  <th
                    style={{
                      minWidth: "200px",
                      textAlign: "left",
                      paddingLeft: "57px",
                      borderLeft: "none",
                      width: "100%",
                    }}
                  ></th>
                ) : preferencias.basededatos == false &&
                  preferencias.clientPrice == false ? (
                  <th
                    style={{
                      minWidth: certificaciones ? "200px" : "460px",
                      textAlign: "left",
                      paddingLeft: "57px",
                      borderLeft: "none",
                      width: "100%",
                    }}
                  ></th>
                ) : (
                  <th
                    style={{
                      minWidth: "300px",
                      textAlign: "left",
                      paddingLeft: "57px",
                      borderLeft: "none",
                      width: "100%",
                    }}
                  ></th>
                )}
                {
                  //UNIDAD Y LUEGO CANTIDAD
                }
                <th style={{ minWidth: "60px", maxWidth: "60px" }}></th>
                <th style={{ minWidth: "64px", maxWidth: "64px" }}></th>
                {
                  //MARGEN
                }
                {preferencias.basededatos == true ? (
                  <th colSpan={"2"} style={{ minWidth: "86px" }}>
                    {i18n.t("")}
                  </th>
                ) : null}
                {
                  // Coste Objetivo
                  preferencias.precioCoste &&
                    (!certificaciones || !isBaseCertClient) && (
                      <th
                        colSpan="2"
                        style={{
                          minWidth: "171px",
                          borderLeft: "1px solid #B7B7B7",
                        }}
                      >
                        {i18n.t("Coste Obj.")}
                      </th>
                    )
                }
                {
                  // Coste Reducido
                  preferencias.costeReducido && !certificaciones && (
                    <th
                      colSpan="3"
                      style={{
                        minWidth: "171px",
                        borderLeft: "1px solid #B7B7B7",
                      }}
                    >
                      {i18n.t("structure.reducedCost")}
                    </th>
                  )
                }
                {
                  // Coste Real
                  preferencias.costReal && !certificaciones && (
                    <th
                      colSpan={preferencias.basededatos == true ? 3 : 2}
                      style={{
                        minWidth: "171px",
                        borderLeft: "1px solid #B7B7B7",
                      }}
                    >
                      {i18n.t("Coste Real")}
                    </th>
                  )
                }
                {
                  // Precio Cliente
                  (certificaciones
                    ? isBaseCertClient
                    : preferencias.clientPrice) && (
                    <th
                      colSpan="2"
                      style={{
                        minWidth: "128px",
                        borderLeft: "1px solid #B7B7B7",
                        borderRight: "1px solid #B7B7B7",
                      }}
                    >
                      {i18n.t("Precio Cliente")}
                    </th>
                  )
                }
                {
                  // Descuento
                  preferencias.descuento && !certificaciones && (
                    <th
                      colSpan="2"
                      style={{
                        minWidth: "15px",
                        maxWidth: "250px",
                        background: "#F3D66338",
                        borderLeft: "1px solid #B7B7B7",
                      }}
                    >
                      {i18n.t("Precio Cliente con descuento")}
                    </th>
                  )
                }
                {
                  // Certificaciones
                  certificaciones && (
                    <th
                      colSpan="7"
                      style={{
                        minWidth: "50px",
                        borderLeft: "1px solid #B7B7B7",
                        maxWidth: "86px",
                        color: "#414141",
                        background: "#F3D66338",
                      }}
                    >
                      {i18n.t("Certificaciones")}
                    </th>
                  )
                }
                {
                  // Opciones
                  <th></th>
                }
              </tr>
            </tbody>

            <tbody>
              <tr id="subCategory">
                <td style={{ borderLeft: "none", width: "79px" }}>
                  {i18n.t("Ref.")}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    borderLeft: "1px solid #E9ECEF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      height: "35px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "100px",
                        borderRight: "1px solid #E9ECEF",
                        paddingLeft: "10px",
                        height: "35px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {i18n.t("Codigo")}
                    </div>
                    <div
                      style={{
                        flex: "1",
                        paddingLeft: "10px",
                      }}
                    >
                      {i18n.t("Descripción")}
                    </div>
                  </div>
                </td>
                <td
                  style={{
                    minWidth: "60px",
                    maxWidth: "60px",
                    borderLeft: "1px solid #E9ECEF",
                  }}
                >
                  {i18n.t("Medición")}
                </td>
                <td style={{ borderLeft: "1px solid #E9ECEF" }}>
                  {i18n.t("Ud.")}
                </td>
                {preferencias.basededatos == true ? (
                  <>
                    <td
                      colSpan={"2"}
                      style={{
                        maxWidth: "86px",
                        borderLeft: "1px solid #E9ECEF",
                      }}
                    >
                      {i18n.t("Márgen")}
                    </td>
                  </>
                ) : null}
                {
                  // Coste Objetivo
                  preferencias.precioCoste && !certificaciones && (
                    <>
                      <td style={{ minWidth: "86px", color: "#414141" }}>
                        {" "}
                        {currencySymbol}/u
                      </td>
                      <td
                        style={{
                          minWidth: "126px",
                          color: "#414141",
                          borderLeft: "1px solid #F3F1F1",
                        }}
                      >
                        {i18n.t("Total")} {currencySymbol}
                      </td>
                    </>
                  )
                }
                {
                  // Coste Reducido
                  preferencias.costeReducido && !certificaciones && (
                    <>
                      <td style={{ minWidth: "86px", color: "#414141" }}>%</td>
                      <td
                        style={{
                          minWidth: "86px",
                          color: "#414141",
                          borderLeft: "1px solid #F3F1F1",
                        }}
                      >
                        {currencySymbol}/u
                      </td>
                      <td
                        style={{
                          minWidth: "126px",
                          color: "#414141",
                          borderLeft: "1px solid #F3F1F1",
                        }}
                      >
                        {i18n.t("Total")} {currencySymbol}
                      </td>
                    </>
                  )
                }
                {
                  // Coste Real
                  preferencias.costReal && !certificaciones && (
                    <>
                      {preferencias.basededatos == true && (
                        <td style={{ minWidth: "86px", color: "#414141" }}>
                          %MR
                        </td>
                      )}
                      <td style={{ minWidth: "126px", color: "#414141" }}>
                        {currencySymbol}/u
                      </td>
                      <td
                        style={{
                          minWidth: "126px",
                          color: "#414141",
                          borderLeft: "1px solid #F3F1F1",
                        }}
                      >
                        {i18n.t("Total")} {currencySymbol}
                      </td>
                    </>
                  )
                }
                {
                  // Precio Cliente
                  (preferencias.clientPrice || certificaciones) && (
                    <>
                      <td style={{ minWidth: "100px" }}>{currencySymbol}/u</td>
                      <td
                        style={{
                          minWidth: "96px",
                          borderLeft: "1px solid #F3F1F1",
                        }}
                      >
                        {i18n.t("Total")} {currencySymbol}
                      </td>
                    </>
                  )
                }
                {
                  // Descuento
                  preferencias.descuento && !certificaciones && (
                    <>
                      <td
                        style={{
                          minWidth: "126px",
                        }}
                      >
                        {i18n.t("%")}
                      </td>
                      <td style={{ minWidth: "126px" }}>{currencySymbol}/u</td>
                      <td
                        style={{
                          minWidth: "126px",
                          borderLeft: "1px solid #F3F1F1",
                        }}
                      >
                        {i18n.t("Total")} {currencySymbol}
                      </td>
                    </>
                  )
                }
                {
                  // Certificaciones
                  certificaciones && (
                    <>
                      <td
                        style={{
                          minWidth: "72px",
                          borderLeft: "1px solid #B7B7B7",
                          maxWidth: "86px",
                          color: "#414141",
                          background: "#F3D66338",
                        }}
                      >
                        {i18n.t("Total")}
                        <br />
                        {i18n.t("(Ud)")}
                      </td>
                      <td
                        style={{
                          minWidth: "72px",
                          borderLeft: "1px solid #B7B7B7",
                          maxWidth: "86px",
                          color: "#414141",
                          background: "#F3D66338",
                        }}
                      >
                        {i18n.t("Total")}
                        <br />
                        {i18n.t("(%)")}
                      </td>
                      <td
                        style={{
                          minWidth: "72px",
                          borderLeft: "1px solid #B7B7B7",
                          maxWidth: "86px",
                          color: "#414141",
                          background: "#F3D66338",
                        }}
                      >
                        {i18n.t("Previo")}
                        <br />
                        {i18n.t("(Ud)")}
                      </td>
                      <td
                        style={{
                          minWidth: "72px",
                          borderLeft: "1px solid #B7B7B7",
                          maxWidth: "86px",
                          color: "#414141",
                          background: "#F3D66338",
                        }}
                      >
                        {i18n.t("Previo")}
                        <br />
                        {i18n.t("%")}
                      </td>
                      <td
                        style={{
                          minWidth: "72px",
                          borderLeft: "1px solid #B7B7B7",
                          maxWidth: "86px",
                          color: "#414141",
                          background: "#F3D66338",
                        }}
                      >
                        {i18n.t("Actual")}
                        <br />
                        {i18n.t("(Ud)")}
                      </td>
                      <td
                        style={{
                          minWidth: "72px",
                          borderLeft: "1px solid #B7B7B7",
                          maxWidth: "86px",
                          color: "#414141",
                          background: "#F3D66338",
                        }}
                      >
                        {i18n.t("Actual")}
                        <br />
                        {i18n.t("(%)")}
                      </td>
                      <td
                        style={{
                          minWidth: "96px",
                          borderLeft: "1px solid #B7B7B7",
                          maxWidth: "128px",
                          color: "#414141",
                          background: "#F3D66338",
                        }}
                      >
                        {i18n.t("Actual")}
                        <br />({currencySymbol})
                      </td>
                    </>
                  )
                }
                {
                  // Opciones
                  <td></td>
                }
              </tr>
            </tbody>

            {children}
            {projectInfo.status === "CLOSED" ||
            version ||
            certificaciones ? null : (
              <tbody>
                <tr id="lastPartida">
                  <td
                    colSpan="2"
                    style={{ borderBottom: "none", textAlign: "left" }}
                  >
                    {!isBudgetClosed && budgetMode !== "tender" && (
                      <Box
                        sx={{
                          marginTop: "18px",
                          marginBottom: "18px",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <AddPartidaActions
                          hideSearch={soyFinal}
                          onSearch={() => {
                            freeTrialExpired
                              ? openFreeTrialExpire()
                              : handleSearchPart()
                          }}
                          onCreateManual={() => {
                            freeTrialExpired
                              ? openFreeTrialExpire()
                              : handleCreatePart()
                          }}
                          onImport={importBC3FromLink}
                          searchButtonProps={{
                            "data-amplify-analytics-on": "click",
                            "data-amplify-analytics-name":
                              "SearchPartPartTable",
                            "data-amplify-analytics-attrs": capitulo,
                            "data-element": "searchPartidaBtn",
                          }}
                          manualButtonProps={{
                            "data-amplify-analytics-on": "click",
                            "data-amplify-analytics-name":
                              "AddNewPartPartTable",
                            "data-amplify-analytics-attrs": capitulo,
                            "data-element": "newPartidaBtn",
                          }}
                          importButtonProps={{
                            "data-amplify-analytics-on": "click",
                            "data-amplify-analytics-name":
                              "AddNewPartPartTable",
                            "data-amplify-analytics-attrs": capitulo,
                            "data-element": "importFromBC3LinkBtn",
                          }}
                        />
                      </Box>
                    )}
                    {budgetMode === "tender" && (
                      <div style={{ fontSize: "12px", fontWeight: "400" }}>
                        {i18n.t("validation.cannotAddPartsInTenderMode")}
                      </div>
                    )}
                  </td>
                  {getLastRow(preferencias, capitulo)}
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
      {entitlementDialog}
    </>
  )
}

Estructura.propTypes = {
  total: propTypes.any,
  children: propTypes.node.iRequired,
  desplazamiento: propTypes.number,
  esUnico: propTypes.bool,
  soyFinal: propTypes.bool,
  totalFinal: propTypes.any,
  ocultoFinal: propTypes.bool,
  capitulo: propTypes.object.isRequired,
  projectInfo: propTypes.object,
  version: propTypes.object,
  openModalCreatePartida: propTypes.bool,
  setOpenModalCreatePartida: propTypes.func,
  certificaciones: propTypes.bool,
}

export default Estructura
